import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class AdminTripContainer extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tripContainer = this;
		setTimeout(function(){
			tripContainer.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var tripContainer = this;
		
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			var unitField = ElementUtil.query(toolbarFilter, 'filterTractorId');
			if (!tripContainer.selectedCompanyId) {
				unitField.items = [];
				return Promise.resolve();
			}

			return UnitService.getUnitLookupService().getUnitsForCompany(tripContainer.selectedCompanyId, refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];

				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					}
				};

				if (selectedUnitId) {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnitsForCompany(tripContainer.selectedCompanyId, refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};		
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [	
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (tripContainer.accountmanagement) {
							Service.getAccountManagementService().getManagedCompanies().then(function(data){
								var lookups = []; 
								data.forEach(function(c) {
									lookups.push({
										code: c.companyId,
										description: c.companyName
									});
								});
								combo.items = lookups;
							});
						} else {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							tripContainer.selectedCompanyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							loadReferenceLookup('TRACTOR');
							ElementUtil.query(toolbarFilter, 'filterTractorId').value = '';
							actionRefresh(true);
						}
					}					
				},				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTractorId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Tractor',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {																	
					},
					placeHolder: 'Select',
					listeners: {
						input: {
							fn: function(e) {
								loadReferenceLookup('TRACTOR', e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-text-field',
					itemid: 'filterTripRefNo',
					label: 'Trip Ref No',
					name: 'tripRefNo',
					listeners: {
						input: {
							fn: function(e) {
								actionRefresh();
							},
							buffer: 1000
						}
					}				
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				}
			]
		});
		
		var tripStopGrid = ElementUtil.create({
			tag: 'dl-admin-trip-stops-grid',
			listeners: {
				'refresh-all' : function() {
					actionRefresh();
				}
			}
		});
		
		var tripGrid = ElementUtil.create({
			tag: 'dl-admin-trip-grid',
			listeners: {
				'refresh-all' : function() {
					actionRefresh();
				}
			}
		});
		
		var distanceGridConfig = {
			'tab-title': '<vaadin-icon icon="vaadin:map-marker"></vaadin-icon> Trip Stops',
			tag: 'div',
			style: 'height: 100%;',
			children: [
				tripStopGrid
			]
		};
		
		var tripSheetConfig = {
			'tab-title': '<vaadin-icon icon="vaadin:package"></vaadin-icon> Trips',
			tag: 'div',
			style: 'height: 100%;',
			children: [
				tripGrid
			]
		};
		
		var tabPanel = ElementUtil.create({
			tag: 'dl-tabpanel',
			slot: 'primary',
			listeners: {
				ready: function() {
					tabPanel.addTabs([
						distanceGridConfig,
						tripSheetConfig
					]);
				}
			}
		});			
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarFilter,
				tabPanel
			]
		});		
		tripContainer.append(flexLayout);			
		
		loadReferenceLookup('TRACTOR', null);	
		
		var actionRefresh = function(clearOnFail) {
			var tractorId = ElementUtil.query(toolbarFilter, 'filterTractorId').value;
			if (tractorId) {				
				actionRefreshTripStops();
				actionRefreshTrips();			
			} else {
				ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').validate();								
				window.DL.MessageUtil.showToastError('A tractor must be selected');
				if (clearOnFail) {
					tripStopGrid.clearGrid();
					tripGrid.clearGrid();
				}
			}	
		};
		
		var actionRefreshTripStops = function() {
			tripStopGrid.refreshGrid();
		};
		
		var actionRefreshTrips = function() {
			tripGrid.refreshGrid();
		};
		
		tripStopGrid.setFilterContainer(toolbarFilter);
		tripGrid.setFilterContainer(toolbarFilter);
		attachWorkspaceFilterState(tripContainer, toolbarFilter,
			['filterCompany','filterTractorId','filterTripRefNo','filterStartDate','filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterTractorId'));
					state.filterTractorId = unitState.value;
					state.filterTractorDescription = unitState.description;
				},
				restore: function(data) {
					if (data.filterCompany !== undefined && data.filterCompany !== null) {
						ElementUtil.query(toolbarFilter, 'filterCompany').value = data.filterCompany;
						tripContainer.selectedCompanyId = data.filterCompany;
					}
					if (data.filterTripRefNo !== undefined && data.filterTripRefNo !== null) {
						ElementUtil.query(toolbarFilter, 'filterTripRefNo').value = data.filterTripRefNo;
					}
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterTractorId'),
						refType: 'TRACTOR',
						unitId: data.filterTractorId,
						description: data.filterTractorDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								if (!tripContainer.selectedCompanyId) {
									return Promise.resolve({data: []});
								}
								return UnitService.getUnitLookupService().getUnitsForCompany(
									tripContainer.selectedCompanyId, referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
		
	}

}
customElements.define('dl-admin-trip-container', AdminTripContainer);

